import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TableComponent } from './table/table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalAlertaComponent } from './modal-alerta/modal-alerta.component';
import { FormComponent } from './form/form.component';
import { UppercaseOnlyDirective } from './directives/uppercase-only.directive';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { CargaArchivosComponent } from './carga-archivos/carga-archivos.component';
import { FormPersonaJuridicaComponent } from '../forms/form-persona-juridica/form-persona-juridica.component';
import { FormPersonaNaturalComponent } from '../forms/form-persona-natural/form-persona-natural.component';
import { TabsComponent } from './tabs/tabs.component';
import { CargueArchivosComponent } from './cargue-archivos/cargue-archivos.component';
import { ModalComponent } from './modal/modal.component';
import { CargueArchivosTramiteComponent } from './archivos-tramite/cargue-archivos-tramite/cargue-archivos-tramite.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalReactiveComponent } from './modal-reactive/modal-reactive.component';
import { TipoDocumentoValidationDirective } from './directives/tipo-documento.directive';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CalendarModule } from 'primeng/calendar';
import { PowerBiEmbedComponent } from './power-bi-embed/power-bi-embed.component';
import { PoliticaTratamientoDatosPersonalesComponent } from './modal-politica/politica-tratamiento-datos-personales/politica-tratamiento-datos-personales.component';
import { ModalDatosAdicionalesComponent } from './modal-datos/modal-datos-adicionales/modal-datos-adicionales.component';
import { ModalDatosAdicionalesAbogadoComponent } from './modal-datos/modal-datos-adicionales-abogado/modal-datos-adicionales-abogado.component';
import { ModalSelectTipoUsuarioComponent } from './modal-select-tipo-usuario/modal-select-tipo-usuario.component';
import { TranslatePipe } from '@ngx-translate/core';

@NgModule({
  declarations: [
    PowerBiEmbedComponent,
    TableComponent,
    ModalAlertaComponent,
    FormComponent,
    CargaArchivosComponent,
    UppercaseOnlyDirective,
    NumbersOnlyDirective,
    TipoDocumentoValidationDirective,
    CargaArchivosComponent,
    CargueArchivosComponent,
    CargaArchivosComponent,
    FormPersonaNaturalComponent,
    FormPersonaJuridicaComponent,
    ModalComponent,
    CargueArchivosTramiteComponent,
    TabsComponent,
    ModalReactiveComponent,
    BreadcrumbComponent,
    PoliticaTratamientoDatosPersonalesComponent,
    ModalDatosAdicionalesComponent,
    ModalDatosAdicionalesAbogadoComponent,
    ModalSelectTipoUsuarioComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgSelectModule,
    CalendarModule,
    NgOptimizedImage,
    TranslatePipe
  ],
  exports: [
    PowerBiEmbedComponent,
    TableComponent,
    UppercaseOnlyDirective,
    TipoDocumentoValidationDirective,
    NumbersOnlyDirective,
    CargaArchivosComponent,
    CargueArchivosComponent,
    CargaArchivosComponent,
    FormComponent,
    FormPersonaNaturalComponent,
    FormPersonaJuridicaComponent,
    ModalComponent,
    CargueArchivosTramiteComponent,
    TabsComponent,
    ModalReactiveComponent,
    BreadcrumbComponent,
    PoliticaTratamientoDatosPersonalesComponent,
    ModalDatosAdicionalesComponent,
    ModalDatosAdicionalesAbogadoComponent,
    ModalSelectTipoUsuarioComponent
  ],
})
export class UtilModule {}
